import amexLogo from "@icons/institutions/amex.svg";
import appleLogo from "@icons/institutions/apple.svg";
import bankOfAmericaLogo from "@icons/institutions/bank-of-america.png";
import capitalOneLogo from "@icons/institutions/capital-one.png";
import cashAppLogo from "@icons/institutions/cash-app.svg";
import chaseLogo from "@icons/institutions/chase.png";
import citiLogo from "@icons/institutions/citi.png";
import coinbaseLogo from "@icons/institutions/coinbase.png";
import lcnbLogo from "@icons/institutions/lcnb.png";
import mercuryLogo from "@icons/institutions/mercury.svg";
import paypalLogo from "@icons/institutions/paypal.svg";
import plaidWhiteLogo from "@icons/institutions/plaid-white.svg";
import plaidLogo from "@icons/institutions/plaid.svg";
import relayLogo from "@icons/institutions/relay.svg";
import robinhoodLogo from "@icons/institutions/robinhood.png";
import stripeLogo from "@icons/institutions/stripe.svg";
import venmoLogo from "@icons/institutions/venmo.svg";
import wellsFargoLogo from "@icons/institutions/wells-fargo.png";
import type { InstitutionArtwork } from "./institutionArtwork";

// ds-deviation: brand colour. Container fills without a matching token are
// brand data, kept as the hex Figma draws (spec I8).

/** Figma's banks, cards, wallets and payment rails. */
export const financeInstitutions = {
    chase: { name: "Chase", glyph: { src: chaseLogo } },
    "wells-fargo": { name: "Wells Fargo", glyph: { src: wellsFargoLogo } },
    robinhood: { name: "Robinhood", glyph: { src: robinhoodLogo } },
    "bank-of-america": {
        name: "Bank of America",
        glyph: { src: bankOfAmericaLogo },
    },
    coinbase: { name: "Coinbase", glyph: { src: coinbaseLogo } },
    "capital-one": { name: "Capital One", glyph: { src: capitalOneLogo } },
    lcnb: {
        name: "LCNB",
        background: "#0f873f",
        glyph: { src: lcnbLogo },
        box: { x: 1, y: 12, width: 38, height: 16 },
    },
    citi: {
        name: "Citi",
        background: "#056cae",
        glyph: { src: citiLogo },
        box: { x: 3, y: 9, width: 32.37, height: 18 },
    },
    stripe: { name: "Stripe", glyph: { src: stripeLogo } },
    plaid: {
        name: "Plaid",
        background: "var(--color-black)",
        glyph: { src: plaidLogo },
        box: { x: 9, y: 8.5, width: 22, height: 22.22 },
    },
    "plaid-white": {
        name: "Plaid White",
        background: "var(--color-white)",
        glyph: { src: plaidWhiteLogo },
        box: { x: 9, y: 8.5, width: 22, height: 22.22 },
    },
    amex: {
        name: "Amex",
        background: "#016fd0",
        glyph: { src: amexLogo },
        box: { x: 0, y: 0, width: 40, height: 39.9 },
    },
    "cash-app": {
        name: "Cash App",
        background: "#00d632",
        glyph: { src: cashAppLogo },
    },
    venmo: { name: "Venmo", background: "#3396cd", glyph: { src: venmoLogo } },
    mercury: {
        name: "Mercury",
        background: "var(--color-white)",
        glyph: { src: mercuryLogo },
        box: { x: 1.24, y: 1, width: 37.52, height: 38 },
    },
    relay: {
        name: "Relay",
        background: "#f1edde",
        glyph: { src: relayLogo },
        box: { x: 4, y: 11.79, width: 32, height: 16.41 },
    },
    paypal: {
        name: "PayPal",
        background: "#e2f0fb",
        glyph: { src: paypalLogo },
        box: { x: 10, y: 8, width: 19.49, height: 24 },
    },
    apple: {
        name: "Apple",
        glyph: { src: appleLogo },
        box: { x: 9.82, y: 6.5, width: 20.35, height: 25 },
    },
} satisfies Record<string, InstitutionArtwork>;
